import { View } from 'react-native';
import type { IconProps } from './index';

const Icon = function ({ icon, style, className = '', color }: IconProps) {
  if (!className.includes('size-')) {
    className += ' size-5';
  }
  const [width, height, name, path] = icon.definition;

  return (
    <View
      className={`flex-row items-center justify-center ${className}`}
      style={style}
      testID={`icon-${icon.name}`}
    >
      <svg
        color={color}
        data-prefix={icon.type}
        data-icon={name}
        className={`svg-inline--fa fa-${name} fa-width-auto h-full overflow-visible`}
        role="img"
        viewBox={`0 0 ${width} ${height}`}
        aria-hidden="true"
      >
        <path fill="currentColor" d={path} />
      </svg>
    </View>
  );
};

export { Icon };
